import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { GetDynamicColumnsResponse, GetDynamicPropertiesResponse, GetDynamicEntityTypesResponse, GetDynamicColumnNamesForEntityTypeResponse } from "../../models/manage/entities.models";
import {Urls} from '../../constants/entities/entities.constants';
import { EntityDynamicValue } from "../../models/basics/basics.models";
import { StringIdGenerator } from "../../utilities/strings";

@autoinject
export class EntityDynamicPropertiesService {

    constructor(private requestClient: RequestClientService) {
    }

    public getDynamicPropertiesForEntity(entityId: number, entityTypeId: number): Promise<GetDynamicPropertiesResponse> {
        const promise = new Promise<GetDynamicPropertiesResponse>((resolve, reject) => {
            this.requestClient.get<any>(Urls.GetDynamicPropertiesForEntity, { entityId, entityTypeId })
                .then((result: any) => {
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    public getDynamicColumnNamesForEntityType(entityTypeId: number): Promise<GetDynamicColumnNamesForEntityTypeResponse> {
        const promise = new Promise<GetDynamicColumnNamesForEntityTypeResponse>((resolve, reject) => {
            this.requestClient.get<any>(Urls.GetDynamicColumnNamesForEntityType, { entityTypeId })
                .then((result: any) => {
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    public getDynamicEntityTypes(): Promise<GetDynamicEntityTypesResponse> {
        const promise = new Promise<GetDynamicEntityTypesResponse>((resolve, reject) => {
            this.requestClient.get<any>(Urls.GetDynamicEntityTypes, null)
                .then((result: any) => {
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    public cloneDynamicColumn(columnId: number, selectedEntityTypeId: number, nextColumnName: string) : Promise<void> {
        const promise = new Promise<void>((resolve, reject) => {
            this.requestClient.post<any>(`${Urls.CloneDynamicColumn}`, {}, {dynamicColumnId : columnId, selectedEntityTypeId: selectedEntityTypeId, columnName: nextColumnName})
            .then((result: any) => {
                resolve(result);
            }, (error) => {
                reject(error);
            });
        })
        return promise;
    }

    public getDynamicColumnsForEntities(entityTypeId: number): Promise<GetDynamicColumnsResponse> {
        const promise = new Promise<GetDynamicColumnsResponse>((resolve, reject) => {
            this.requestClient.get<any>(Urls.GetDynamicColumnsForEntities, { entityTypeId })
                .then((result: any) => {
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    public saveDynamicColumnsForEntities(changes: any): Promise<GetDynamicColumnsResponse> {
        return this.requestClient.post<GetDynamicColumnsResponse>(Urls.SaveDynamicColumnsForEntities, {}, { changes });
    }

    public saveDynamicPropertiesForEntity(entityDynamicValues: EntityDynamicValue[], isAudit: boolean = false): Promise<GetDynamicPropertiesResponse> {
        return this.requestClient.post<GetDynamicPropertiesResponse>(Urls.SaveDynamicPropertiesForEntity, {}, { entityDynamicValues, isAudit });
    }

    public getNextLetter(stringGenerator: StringIdGenerator, usedLetters: string[]){
        let nextLetter = stringGenerator.next();
            while (usedLetters.indexOf(nextLetter) > -1 || nextLetter == "id") {
                nextLetter = stringGenerator.next();
            }
        return nextLetter;
    }
}
